module.exports = __webpack_public_path__ + "img/line-top.69f26b05.svg";